import {RouteObject, redirect} from 'react-router';

import {ECompanyNewsTab} from './definitions';

const children: RouteObject[] = [
  {
    index: true,
    loader: () => redirect(ECompanyNewsTab.BLOG),
  },
  {
    path: ECompanyNewsTab.BLOG,
    lazy: async () => ({
      Component: (await import('./CompanyNews')).Blog,
    }),
  },
  {
    path: ECompanyNewsTab.CASES,
    lazy: async () => ({
      Component: (await import('./CompanyNews')).Cases,
    }),
  },
];

export const newsRoutes: RouteObject = {children};
